import { Icon } from '@purpur/library/icon';
import styled from 'styled-components';

import { purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

import { NetflixLogoRoundIcon } from './NetflixLetterLogoRound';

export const NetflixIconModeDesktop = styled(NetflixLogoRoundIcon)``;
export const NetflixIconModeMobile = styled(Icon).attrs({ size: 'md' })``;

const netflixIconModeDesktopSelector: string = NetflixIconModeDesktop;
const netflixIconModeMobileSelector: string = NetflixIconModeMobile;

export const DualMode = styled.span.attrs({ role: 'presentation' })`
    ${purpurMedia('sm')`
        ${netflixIconModeDesktopSelector} { display: none; }
        ${netflixIconModeMobileSelector} { display: flex; }
    `}
    ${purpurMedia('lg')`
        ${netflixIconModeDesktopSelector} { display: flex; }
        ${netflixIconModeMobileSelector} { display: none; }
    `}
`;
